import type {
  FilterRuleListResponse,
  MailboxFilterRule,
  FilterRuleCreateInput,
  FilterRuleUpdateInput,
} from "@cdt/shared";

import { api } from "@/lib/api";

export async function fetchFilterRules(): Promise<FilterRuleListResponse> {
  return api.get<FilterRuleListResponse>("/api/filters");
}

export async function createFilterRule(
  payload: FilterRuleCreateInput,
): Promise<MailboxFilterRule> {
  return api.post<MailboxFilterRule>("/api/filters", payload);
}

export async function updateFilterRule(
  id: string,
  payload: FilterRuleUpdateInput,
): Promise<MailboxFilterRule> {
  return api.patch<MailboxFilterRule>(`/api/filters/${encodeURIComponent(id)}`, payload);
}

export async function deleteFilterRule(id: string): Promise<void> {
  await api.delete<unknown>(`/api/filters/${encodeURIComponent(id)}`);
}
